module.exports = __webpack_public_path__ + "img/img46.496a9dfa.jpg";